export function getBaseTextStyle(theme, color, marginBottom, textAlign) {
    return {
        root: {
            color: color,
            marginBottom: marginBottom,
            textAlign: textAlign ? textAlign : "center",
        },
    };
}
